// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "HouseEditForm__textCenter__m7ET4";
export const mobileTitle = "HouseEditForm__mobileTitle__ChJxW TransactionEditForm__title__4dnvO font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const formHeight = "HouseEditForm__formHeight__Fnl-h";
export const form = "HouseEditForm__form__20znT";
export const line = "HouseEditForm__line__vW-Gg";
export const item = "HouseEditForm__item__5wppa HouseEditForm__line__vW-Gg";
export const buttonRowWrapper = "HouseEditForm__buttonRowWrapper__T6VG0";
export const onSettingsPage = "HouseEditForm__onSettingsPage__cjGxK";
export const submitItem = "HouseEditForm__submitItem__ewAzO";
export const buttonsRow = "HouseEditForm__buttonsRow__EXwBB";
export const button = "HouseEditForm__button__ierCW";